import { Box } from '@mui/material';
import Navbar from './Navbar';
import { useLocation } from "react-router-dom";

const PageLayout = ({ children }) => {
    const location = useLocation();

    // Adjust condition to hide footer based on report routes
    const hideFooter = /^\/[^/]+\/[^/]+\/[^/]+$/.test(location.pathname); // matches /dashboard/report/page

    return (
        <Box sx={{ height: '100%', width: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
            <Box sx={{ flexShrink: 0 }}>
                <Navbar />
            </Box>

            <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
                {children}
            </Box>

            {!hideFooter && (
                <Box sx={{ flexShrink: 0, bgcolor: 'grey.200', textAlign: 'center', py: 1 }}>
                    <small>© 2025 Bosch Smart Pulse</small>
                </Box>
            )}
        </Box>
    );
};

export default PageLayout;
